import {forEach} from "lodash";
import {getInputValue, isNull, replaceInText} from "../../helpers";

export class ValidationService {
    constructor(form) {
        this.form = form;
        this.idNumberValidationUrl = $("#validate-id-number").val();
        this.valid = true;
        this.errors = [];
        this.inputsExceptions = [];
        this.inputsExceptionsClasses = [".vat_amount", ".vat_refund_amount"];
    }

    get scanContainer() {
        return this.form.attachmentsForm.scanContainerElement;
    }

    get attachmentsContainer() {
        return this.form.attachmentsForm.attachmentsContainerElement;
    }

    get attachments() {
        return this.attachmentsContainer.find(this.form.attachmentsForm.attachmentSelector);
    }

    get recipient() {
        return this.form.contractorForm.recipient;
    }

    get isVisibleRecipient() {
        return this.recipient !== undefined ? this.recipient.idNumber.is(":visible") : false;
    }

    get scanElements() {
        return {
            file: this.scanContainer.find('input[name="document_scan"]'),
            name: this.scanContainer.find('input[name="document_scan_name"]'),
        };
    }

    get requiredForFinalInputs() {
        return $(".required_for_final:visible:enabled:not([readonly]):not([disabled])");
    }

    get requiredForCompleted() {
        return $(".required_for_completed:visible:enabled:not([readonly]):not([disabled])");
    }

    getInputs(type) {
        switch (type) {
            case "final":
                return this.requiredForFinalInputs;

            case "completed":
                return this.requiredForCompleted;

            default:
                return [];
        }
    }

    clearValidation() {
        this.valid = true;
    }

    async validate(type, withErrors = true) {
        this.clearValidation();
        this.clearErrors();
        this.validateInputs(type, withErrors);
        this.validatePaymentDueDate(withErrors);
        if($("input[name='country_code']").val() == 'pl' && $('#payments-container').is(":visible") && $('.include-in-document:visible').length > 0){
            this.validateIncludeInDocument(withErrors)
        }
        if($('#can-validate-ksef-date-issued').val() == 1 && ($('#contractor_name').find(":selected").data("natural-person") === 0 || $('#sending-natural-person').val() == 1)){
            this.validateDateIssued(withErrors);
        }
        await this.validateRecipientNumber();

        return this.valid;
    }
    validateIncludeInDocument(withErrors= true){
        if($('.include-in-document:checked').length == 0){
            this.addValidationMessage($('.include-in-document:visible').first(), [$.i18n._("atleast_one_checkbox_must_be_selected")]);
            this.valid = false;
        }

    }
    validateDateIssued(withErrors= true){
        let dateIssued = $("input[name='date_issued']").val();
        let dateMin = $("input[name='date_issued']").data('date_issued_min')
        let dateMax = $("input[name='date_issued']").data('date_issued_max')

        let issued = dateIssued ? new Date(dateIssued) : null;
        let min = dateMin ? new Date(dateMin) : null;
        let max = dateMax ? new Date(dateMax) : null;

        let isValid = true;
        if (min !== null && issued < min) {
            isValid = false;
        }
        if (max !== null && issued > max) {
            isValid = false;
        }

        if (!isValid) {
            this.addValidationMessage($("input[name='date_issued']"), [$.i18n._("date_issued_invalid_ksef_range")]);
            this.valid = false;
        }
    }
    isValidForFinal() {
        this.clearValidation();

        forEach(this.requiredForFinalInputs, element => {
            const input = $(element);
            const name = input.attr("name");
            const value = getInputValue(input);

            if (!this.inputsExceptions.includes(name) && (!value || ["0", "", 0, false, undefined].includes(value))) {
                this.valid = false;
                return false;
            }
        });


        return this.valid;
    }

    validateInputs(type, withErrors = true) {
        const inputs = this.getInputs(type);

        forEach(inputs, element => {
            if (!this.inputsExceptions.includes($(element).attr("name"))) {
                this.validateInput($(element), withErrors);
            }
        });
    }

    validateInput(input, withError = true) {
        const value = getInputValue(input);

        if (!value || ["0", "", 0, undefined].includes(value)) {
            if (withError) {
                const validationMessage = replaceInText($.i18n._("required_field_msg"), {":fieldName": input.data("label")});
                this.addValidationMessage(input, [validationMessage]);
            }

            this.valid = false;
        }
    }

    validateNameFileForm(fileInput, nameInput) {
        const {file, fileInputName} = fileInput;
        const {name, nameInputName} = nameInput;
        const isAddedFile = file.prop("files") != null && file.prop("files").length > 0;
        const isSavedFile = file.val() === 1;

        if ((isAddedFile || isSavedFile) && isNull(name.val())) {
            const validationMessage = replaceInText($.i18n._("document_field_is_required_if_second_field"), {
                ":fieldName": fileInputName, ":secondFieldName": nameInputName,
            });

            this.addValidationMessage(name, [validationMessage]);
            this.valid = false;
        }
    }

    validateScanForm() {
        const {file, name} = this.scanElements;
        this.validateNameFileForm({file, fileInputName: $.i18n._("scan_name")}, {
            name, nameInputName: $.i18n._("document_scan"),
        });
    }

    validateAttachmentForms() {
        forEach(this.attachments, attachment => {
            const {file, name} = this.getAttachmentInputs($(attachment));

            this.validateNameFileForm({
                file, fileInputName: $.i18n._("document_attachment_name"),
            }, {name, nameInputName: $.i18n._("attachment")});
        });
    }


    validatePaymentDueDate(withError = true) {
        forEach(this.form.paymentsForm.paymentForms, (form) => {
            const formDueInput = $(form).find(this.form.paymentsForm.formSelectors.dueDate)
            if($('input[name="payment_correction"]').is(':visible') && $('input[name="payment_correction"]').is(':checked')){
                return;
            }
            if(moment(formDueInput.val()).isBefore(this.form.dateIssued.value)) {
                if (withError) {
                    const validationMessage = replaceInText($.i18n._("after_or_equal_msg"), {":fieldName": $.i18n._('due_date'), ":secondFieldName": $.i18n._('date_issued')});
                    this.addValidationMessage(formDueInput, [validationMessage]);
                }

                this.valid = false;
            }
        });

    }

    getAttachmentInputs(formElement) {
        return {
            file: formElement.find('input[name*="file"]'), name: formElement.find('input[name*="name"]'),
        };
    }

    async validateRecipientNumber() {
        let recipientData = (this.form.contractorForm.recipientForm.getSectionData())
        if ($('.toggle-recipient').is(":checked")) {
            const {isValid, errors} = await $.post(this.idNumberValidationUrl, {
                identification_number: recipientData.id_number,
                identification_number_id: recipientData.id_type,
            });

            if (!isValid) {
                this.addValidationMessage($('input[name="recipient[id_number]"]'), errors);
                this.valid = false;
            }
        }
    }

    clearInputErrors(inputElement) {
        const closestDiv = inputElement.closest("div");
        const isInputGroup = closestDiv.hasClass("input-group");
        const isInputFile = inputElement.attr("type") === "file";
        const wrapper = isInputGroup || isInputFile ? closestDiv.parent() : closestDiv;

        closestDiv.removeClass("has-error");
        wrapper.find("span.help-block").remove();
    }

    clearAttachmentsErrors() {
        forEach(this.attachments, attachment => {
            const {name} = this.getAttachmentInputs($(attachment));
            this.clearInputErrors(name);
        });
    }

    clearErrors() {
        this.clearAttachmentsErrors();
        forEach(this.errors, input => {
            this.clearInputErrors(input);
        });
        this.errors = [];
    }

    prepareWrappedErrorMessageTemplate(messages = [], extraMargin = false, hasError = false) {
        if(!extraMargin){
            return `<span class="help-block text-danger font-weight-normal">${this.prepareErrorMessageTemplate(messages)}</span>`;
        }
       else{
            if(hasError){
                $('#payment_account').css('margin-bottom', "-17px");
            }
             else{
                $('#payment_account').css('margin-bottom', "0px");
            }
            return `<span class="help-block text-danger font-weight-normal">${this.prepareErrorMessageTemplate(messages)}</span>`;
        }
    }

    prepareErrorMessageTemplate(messages = []) {
        return messages.length === 0 ? '' : `${messages.reduce((errors, message) => `${errors} <br> ${message}`)}`;
    }


    addValidationMessage(input, messages = []) {
        const closestDiv = input.closest("div");
        const isInputGroup = closestDiv.hasClass("input-group");
        const isInputFile = input.attr("type") === "file";
        const isSelect2 = closestDiv.find(".select2").length > 0;
        const errorBox = closestDiv.find(".help-block.text-danger");

        const errorsHtml = errorBox.length === 0 ? this.prepareWrappedErrorMessageTemplate(messages) : this.prepareErrorMessageTemplate(messages);

        closestDiv.addClass("has-error");

        if (errorBox.length === 0) {
            const element = isInputGroup || isInputFile || isSelect2 ? closestDiv : input;

            if (isSelect2) {
                element.append(errorsHtml);
            } else {
                element.after(errorsHtml);
            }
        } else {
            errorBox.html(errorsHtml);
        }

        this.errors.push(input);
    }
}
